import { combineReducers } from 'redux';
import gallery from './society/gallery-reducer';
import directorProfile from './society/director-table-reducer';
import home from './society/homeImg-reducer';
import mobSpecification from './society/mob-specification-reducer';
import aboutUs from './society/about-reducer';
import soMember from './society/so-member-reducer';
import branchTable from './society/branch-table-reducer';
import internalNotification from './society/internal-notification-reducer';
import login from './design-reducers';
import changePass from './change-pass-reducer';
import cardComponent from './society/card-component-reducer';

const appReducer = combineReducers({
    cardComponent,
    gallery,
    home,
    mobSpecification,
    changePass,
    directorProfile,
    soMember,
    aboutUs,
    branchTable,
    internalNotification,
    login,
})

const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/combineReducers.js